/* eslint-disable no-param-reassign */
import { type PayloadAction, type Slice, createSlice } from "@reduxjs/toolkit"

import type { IRootState } from "@/3514/store"

import {
    type TCoachDashboardQueryOrder as TOrder,
    type TCoachDashboardQueryPeriod as TPeriod
} from "./coach.dashboard.api.types"
import {
    ECoachDashboardActiveTab as EActiveTab,
    ECoachDashboardTableColumnName as ETableColumnName,
    type TCoachDashboardTableSortConfig as TSortConfig
} from "./coach.dashboard.ui.types"

interface ICoachDashboardState {
    activeTab: EActiveTab
    searchValue: string
    paginationPage: number
    period: TPeriod
    queryOrder: TOrder
    sortConfig: TSortConfig
}

const COACH_DASHBOARD_REDUCER_NAME: string = "coach_dashboard"

const initialState: ICoachDashboardState = {
    activeTab: EActiveTab.Sessions,
    searchValue: String(""),
    paginationPage: 1,
    period: "upcoming_sessions",
    queryOrder: "-start",
    sortConfig: { colName: ETableColumnName.Participants_Name, type: "desc" }
}

const slice: Slice = createSlice({
    name: COACH_DASHBOARD_REDUCER_NAME,
    initialState,
    reducers: {
        changeTab(state: IRootState, { payload }: PayloadAction<EActiveTab>): void {
            state.activeTab = payload
        },
        setSearchValue(state: IRootState, { payload }: PayloadAction<string>): void {
            state.searchValue = payload
        },
        setPaginationPage(state: IRootState, { payload }: PayloadAction<number>): void {
            state.paginationPage = payload
        },
        changeQueryPeriod(state: IRootState, { payload }: PayloadAction<TPeriod>): void {
            state.period = payload
        },
        changeQueryOrder(state: IRootState, { payload }: PayloadAction<TOrder>): void {
            state.queryOrder = payload
        },
        changeSortConfig(state: IRootState, { payload }: PayloadAction<TSortConfig>): void {
            state.sortConfig = payload
        },
        reset(_state: IRootState): IRootState {
            return { ...initialState }
        }
    }
})

const { reducer: coachDashboardReducer, actions: coachDashboardReducerActions }: Slice = slice

export { coachDashboardReducerActions, coachDashboardReducer, COACH_DASHBOARD_REDUCER_NAME }
export type { ICoachDashboardState }
